import * as React from 'react';
import S from './TitleBlock.styles';
const TitleBlock = ({ children, level = 'h2', lineAfter = false, ...otherProps }) => {
    return (React.createElement(S.Title, { as: level, "data-line-after": lineAfter, ...otherProps },
        React.createElement(S.Text, null, children)));
};
export default TitleBlock;
